import { ADD_ORDER_ITEM, REMOVE_ORDER_ITEM, REMOVE_ALL_ORDER_ITEMS, INC_ORDER_ITEM, DEC_ORDER_ITEM } from '../constants/action-items';

export const addOrderItem = item => ({type: ADD_ORDER_ITEM, payload: item});
export const removeOrderItem = index => ({type: REMOVE_ORDER_ITEM, payload: index});
export const removeAllOrderItems = index => ({type: REMOVE_ALL_ORDER_ITEMS});
export const incrementOrderItem = index => ({type: INC_ORDER_ITEM, payload: index});
export const decrementOrderItem = index => ({type: DEC_ORDER_ITEM, payload: index});